export default [
    {title: "General.SubscriptionType.Monthly", value: "Monthly"},
    {title: "General.SubscriptionType.Yearly", value: "Yearly"}
    /*{title: "General.SubscriptionType.Quarterly", value: "Quarterly"}*/
]
